import {type DiscoveryNode, type DiscoveryStrategyFactory, DiscoveryStrategyPriorities} from '../discovery/index.ts';
import {stat} from 'node:fs/promises';
import {lookup} from 'node:dns/promises'
import {KubernetesDiscoveryStrategy} from './KubernetesDiscoveryStrategy.ts';
import type {Properties, PropertyDefinition} from '../config/Properties.ts';
import {
    EXPOSE_EXTERNALLY, KUBERNETES_API_TOKEN,
    KUBERNETES_MASTER_URL,
    NAMESPACE, POD_LABEL_NAME, POD_LABEL_VALUE, RESOLVE_NOT_READY_ADDRESSES,
    SERVICE_DNS,
    SERVICE_LABEL_NAME,
    SERVICE_LABEL_VALUE,
    SERVICE_NAME, SERVICE_PORT
} from './KubernetesProperties.ts';
import {type ClusterTopologyIntentTracker} from '../instance/ClusterTopologyIntentTracker.ts';
import {type Logger} from '../logging.ts';

const PROPERTY_DEFINITIONS: ReadonlyArray<PropertyDefinition> = [
    SERVICE_DNS,
    SERVICE_NAME,
    SERVICE_LABEL_NAME,
    SERVICE_LABEL_VALUE,
    NAMESPACE,
    POD_LABEL_NAME,
    POD_LABEL_VALUE,
    RESOLVE_NOT_READY_ADDRESSES,
    EXPOSE_EXTERNALLY,
    KUBERNETES_MASTER_URL,
    KUBERNETES_API_TOKEN,
    SERVICE_PORT
];

export class KubernetesDiscoveryStrategyFactory implements DiscoveryStrategyFactory {
    private readonly tokenPath: string;
    readonly priority = DiscoveryStrategyPriorities.PLATFORM;
    constructor(tokenPath = '/var/run/secrets/kubernetes.io/serviceaccount/token') {
        this.tokenPath = tokenPath;
    }

    private async defaultKubernetesMasterReachable() {
        try {
            await lookup('kubernetes.default.svc');
            return true;
        } catch (e) {
            // todo log that io.Bridge running on Kubernetes, but "kubernetes.default.svc" is not reachable.
            return false;
        }
    }

    async tokenFileExists(){
        try {
            await stat(this.tokenPath);
            return true;
        } catch (e) {
            return false;
        }
    }

    async isAutoDetectionApplicable() {
        return await this.tokenFileExists() && await this.defaultKubernetesMasterReachable()
    }

    newDiscoveryStrategy(node: DiscoveryNode | undefined, logger: Logger, properties: Properties) {
        const tracker = node?.properties.get("internal.discovery.cluster.topology.intent.tracker");
        return new KubernetesDiscoveryStrategy(logger, properties, tracker as ClusterTopologyIntentTracker | undefined);
    }

    getConfigurationProperties(): ReadonlyArray<PropertyDefinition> {
        return PROPERTY_DEFINITIONS;
    }
}
